// extracted by mini-css-extract-plugin
export default {"zoomModal":"o2-z"};